import React, {Component} from 'react';
import {LoginLink} from '../../components/user';
import {images} from '../../utils/images';
import {CmsLinksHeader} from '../../components/cms';
import {Link} from 'react-router-dom'
import {Container,Row, Col} from 'reactstrap';

export default class Header extends Component {
  render() {
    return (
      <header className="header page-header">
        <Container>
          <Row>
            <Col xs="12" sm="10" md="2" lg="2" className="section-column-left">
              <Link to="/">
                <figure className="figure">
                  <img src={images.getLogo()} alt="logo" className="logo-header"/>
                </figure>
              </Link>
            </Col>
            <Col xs="12" sm="10" md="10" lg="10" className="section-column-right">
              <article className="article">
                <aside className="aside">
                  <h1 className="title1">Notre offre de formation pour l'expertise <strong>informatique Big Data</strong></h1>
                  <section className="aside-topmenu">
                      <a className="a" href=""><i className="fas fa-phone"></i>&nbsp;&nbsp;01 83 64 17 94</a>
                      
                      <LoginLink />
                  </section>  
                </aside>
                <aside className="aside aside-menu">
                  <CmsLinksHeader category={2}/>
                </aside>
            </article>
            </Col>
          </Row>
        </Container>
      </header>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Header/index.js